import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, MessageCircle } from 'lucide-react';

/**
 * Mobile App Splash (P1)
 * ----------------------
 * Minimal first-launch screen for the Capacitor build:
 *   - BodyCorp365 logo
 *   - Single "Enter" button → /login
 *   - Small footer link to chat with Bo-Dy without an account
 *
 * Route: /app-home (manifest start_url + capacitor.config.json server.url)
 */
export default function AppHome() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-between px-6 py-12" data-testid="app-home">
      <div className="flex-1" />

      <div className="flex flex-col items-center w-full max-w-xs">
        <img
          src="/logo.png"
          alt="BodyCorp365"
          className="w-32 h-32 mb-6 select-none drop-shadow-sm"
          draggable={false}
          data-testid="app-home-logo"
        />
        <h1 className="text-3xl font-semibold tracking-tight text-slate-900">BodyCorp365</h1>
        <p className="mt-2 text-sm text-slate-500 text-center">
          Community management, made simple.
        </p>

        <Button
          className="mt-12 w-full h-12 bg-indigo-600 hover:bg-indigo-700 text-base"
          onClick={() => navigate('/login')}
          data-testid="app-home-enter-btn"
        >
          Enter <ArrowRight className="w-4 h-4 ml-2" />
        </Button>
      </div>

      <div className="flex-1" />

      <footer className="text-center text-xs text-slate-400 space-y-2">
        <button
          onClick={() => window.dispatchEvent(new Event('bo-dy:open'))}
          className="inline-flex items-center gap-1.5 text-indigo-600 hover:text-indigo-700 font-medium"
          data-testid="app-home-chat-bo-dy-btn"
        >
          <MessageCircle className="w-3.5 h-3.5" /> Chat with Bo-Dy
        </button>
        <div>© BodyCorp365</div>
      </footer>
    </div>
  );
}
